// React
import MetaTags from 'react-meta-tags';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row, Card, Spinner } from 'reactstrap';
import { useParams, useLocation, useHistory } from 'react-router-dom';

// Containers Injections & Components
import { ModalProposalDetails } from './components/ModalProposalDetails';
import { ProposalsInjection } from '../../containers/proposalsInjection';
import { PageWrapper, DataTable } from '../../containers/componentsInjection';
import { RemoteSearchBySituation } from './components/RemoteSearchBySituation';

// Helpers
import { useLoading } from '../../../../hook/useLoading';
import { APIClient } from '../../../../helpers/api_helper';

export const ProposalsDatatableSituation = () => {
  const [sort, setSort] = useState('asc');
  const [search, setSearch] = useState('');
  const [perPage, setPerPage] = useState(10);
  const [isOpen, setIsOpen] = useState(false);
  const [columnSort, setColumnSort] = useState(1);
  const [proposalSelected, setProposalSelected] = useState(null);

  const api = new APIClient();
  const history = useHistory();
  const { filter } = useParams();
  const location = useLocation();
  const { toggleLoading, setLoading } = useLoading();

  const {
    proposalsBySituation,
    getProposalsBySituation,
    successSituation,
    loadingBySituation,
  } = ProposalsInjection();

  function toggle(data) {
    setProposalSelected(data);
    setIsOpen(!isOpen);
  }

  const handleExportExcel = () => {
    toggleLoading();
    api
      .get(
        `/proposal/export-by-situation/${filter}?office=${location.state}&search=${search}`
      )
      .then((response) => {
        const linkSource = `data:text/plain;base64, ${response.data}`;
        const downloadLink = document.createElement('a');
        const fileName = response.filename;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Associado</span>,
      sortable: true,
      width: '18%',
      selector: (cell) => {
        return (
          <div className="d-grid ">
            <span>{cell.customer}</span>
            <span className="fs-11 text-muted">{cell.cpf}</span>
          </div>
        );
      },
    },
    {
      name: <span className="font-weight-bold fs-13">Plano</span>,
      sortable: true,
      width: '14%',
      selector: (cell) => {
        return (
          <div className="d-grid">
            <span>{cell.plan}</span>
            <span className="fs-11 text-muted">{cell.category}</span>
          </div>
        );
      },
    },
    {
      name: <span className="font-weight-bold fs-13">Número</span>,
      selector: (row) => row.number,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Corretor</span>,
      selector: (row) => row.seller_name,
      sortable: true,
      width: '15%',
    },
    {
      name: <span className="font-weight-bold fs-13">Data Venda</span>,
      selector: (row) => row.sale_at,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Vigência</span>,
      selector: (row) => row.valid_until,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Válido Até</span>,
      selector: (row) => row.valid_until,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Valor</span>,
      selector: (row) => row.price,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Situação</span>,
      sortable: false,
      selector: (cell) => {
        return (
          <div>
            <span className={`badge badge-soft-${cell.status_color}`}>
              {cell.status}
            </span>
          </div>
        );
      },
    },
  ];

  const handleChangeRowsPerPage = async (newPerPage, page) => {
    setPerPage(newPerPage);
    await getProposalsBySituation(location.state || '', filter, {
      page: page,
      length: newPerPage,
      search: search,
      order_column: columnSort,
      order_dir: sort,
    });
  };

  const handleChangePage = async (page) => {
    await getProposalsBySituation(location.state || '', filter, {
      page: page,
      length: perPage,
      search: search,
      order_column: columnSort,
      order_dir: sort,
    });
  };

  const handleSort = async (column, sortDirection) => {
    setSort(sortDirection);
    setColumnSort(column.id - 1);
    await getProposalsBySituation(location.state || '', filter, {
      page: 1,
      length: perPage,
      search: search,
      order_column: column.id - 1,
      order_dir: sortDirection,
    });
  };

  const handleSearch = async (event) => {
    setSearch(event);
    await getProposalsBySituation(location.state || '', filter, {
      page: 1,
      length: perPage,
      search: event,
      order_column: 1,
      order_dir: 'asc',
    });
  };

  useEffect(() => {
    getProposalsBySituation(location.state || '', filter, {
      page: 1,
      length: perPage,
      search: search,
      order_column: 1,
      order_dir: 'asc',
    });
  }, [filter, perPage, successSituation]);

  return (
    <PageWrapper title={'Propostas'}>
      <Row>
        <Col xs={12}>
          <Card>
            <RemoteSearchBySituation
              handleSearch={handleSearch}
              handleExportExcel={handleExportExcel}
            />
            <DataTable
              loading={loadingBySituation}
              progressPending={loadingBySituation}
              progressComponent={
                <Spinner
                  type="grow"
                  color="primary"
                  style={{
                    margin: 25,
                  }}
                />
              }
              data={proposalsBySituation ? proposalsBySituation.data : []}
              columns={columns}
              canSearch={false}
              noDataComponent={null}
              actions={[
                {
                  id: 1,
                  name: 'view',
                  label: 'Visualizar detalhes da proposta',
                  onPress: (cellProps) => toggle(cellProps),
                  icon: 'ri-file-search-line',
                  classNameColorIcon: 'primary',
                },
              ]}
              paginationServer
              pagination
              perPage={perPage}
              sortServer
              onSort={handleSort}
              paginationTotalRows={
                proposalsBySituation ? proposalsBySituation.recordsTotal : 0
              }
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
            {(!proposalsBySituation ||
              proposalsBySituation.data.length === 0) && (
              <>
                <lord-icon
                  src="https://assets7.lottiefiles.com/packages/lf20_fmieo0wt.json"
                  trigger="loop"
                  colors="primary:#dc3545,secondary:#dc3545"
                  style={{ width: '100%', height: '150px' }}
                ></lord-icon>
                <p className="text-center">Nenhuma proposta encontrada</p>
              </>
            )}{' '}
          </Card>
        </Col>
      </Row>

      <ModalProposalDetails
        isOpen={isOpen}
        toggle={toggle}
        history={history}
        hashidProposal={proposalSelected && proposalSelected.hashid}
      />
    </PageWrapper>
  );
};
